import React, { 
  useContext, useMemo, useState
} from 'react';

import useTaskRunList from '../../../utils/hooks/use_task_run_list';

const TaskRunListContext = React.createContext({
  allTaskRuns: [],
  taskRunInfo: [],
  error: null,
  loading: false,
  setTaskRunInfo: () => {}
})

export const TaskRunListContextProvider = ({ children, taskRunFilter = {} }) => {
  const [taskRunInfo, setTaskRunInfo] = useState([])

  const ids = taskRunInfo?.length ? taskRunInfo.map(({ id }) => id) : [];

  const { taskRunListData, loading, error } = useTaskRunList({ taskRunFilter, ids });
  const allTaskRuns = useMemo(() => {
    return taskRunListData?.length ? taskRunListData.map((runs, i) => runs.map(run => ({
      ...run,
      name: taskRunInfo[i]?.name,
      run_type: taskRunInfo[i]?.runType,
      lastRuns: taskRunInfo[i]?.lastRuns,
      schedule: taskRunInfo[i]?.schedule
    }))).flat() : []
  }, [taskRunInfo, taskRunListData]);

  const contextValue = useMemo(() => ({
    allTaskRuns,
    taskRunInfo,
    setTaskRunInfo,
    loading,
    error,
  }), [allTaskRuns, error, loading, taskRunInfo])

  return (
    <TaskRunListContext.Provider value={contextValue}>
      {children}
    </TaskRunListContext.Provider>
  )
}

export const useTaskRunContext = () => useContext(TaskRunListContext)

export default useTaskRunContext;
